import { fetchEdgeControllersData } from '../../../shared/lib/fetchEdgeControllersData';

export const FETCH_EDGE_CONTROLLER_DEVICE = 'edgeControllerDetails/FETCH_DEVICE';
export const FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS = 'edgeControllerDetails/FETCH_DEVICE_SUCCESS';
export const FETCH_EDGE_CONTROLLER_DEVICE_FAILURE = 'edgeControllerDetails/FETCH_DEVICE_FAILURE';
export const CLEAR_EDGE_CONTROLLER_DEVICE = 'edgeControllerDetails/CLEAR_DEVICE';

export const fetchEdgeControllerDevice = (deviceId) => async (dispatch) => {
  dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE });

  try {
    const devices = await fetchEdgeControllersData();
    const device = devices.find(({ device_id }) => device_id === deviceId) || null;

    dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS, payload: device });
  } catch {
    dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE_FAILURE });
  }
};

export const clearEdgeControllerDevice = () => ({ type: CLEAR_EDGE_CONTROLLER_DEVICE });

